import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { Symbols } from '@/symbols';
import { E_ACCOUNT_STATUS } from '@/apis/service/AccountApi.types';
import _ from 'lodash';
import { E_PrivliegeLimitationWay } from '@/apis/service/PackageApi.types';
let AccountDefaultService = class AccountDefaultService {
    constructor(accountApi, packageApi, privilegeDataService) {
        this.accountApi = accountApi;
        this.packageApi = packageApi;
        this.privilegeDataService = privilegeDataService;
        this.putAccountsSetting = this.accountApi.putAccountsSetting;
        this.putTenantUsersIndividual = this.accountApi.putTenantUsersIndividual;
    }
    // accountBaseInfo: IAccount = {} as any
    getAccountDetail(id) {
        return this.accountApi.getAccountDetail(id).then(res => {
            // this.accountBaseInfo = res
            return res;
        });
    }
    getAccountSendEmail(id) {
        return this.accountApi.getAccountSendEmail(id);
    }
    /**
     *  禁用 jie
     */
    patchAccountsBlock(params) {
        return this.accountApi.patchAccountsBlock(params);
    }
    /**
     * 解禁
     */
    patchAccountsUnblock(user_id) {
        return this.accountApi.patchAccountsUnblock({ user_id });
    }
    /**
     * 解锁
     */
    unlock(id) {
        return this.accountApi.patchAccountUnlock(id);
    }
    getPermissionByAccountInfo(type, accountInfo, tenantUser = {}) {
        const account_status = accountInfo.account_status_combine;
        let hasPermission = false;
        switch (type) {
            case 'resendWelcomeEmail':
                hasPermission = Boolean(tenantUser.enabled);
                break;
            case 'modifyUserPermissions':
                hasPermission = Boolean(tenantUser.enabled);
                break;
            case 'modifyPassword':
                hasPermission = accountInfo.change_password;
                break;
            case 'remove':
                hasPermission = !!tenantUser?.tenant_id && tenantUser.enabled;
                break;
            case 'unlock':
                hasPermission = accountInfo.login_locked;
                break;
            case 'block':
                hasPermission = E_ACCOUNT_STATUS.canUseBlock(account_status);
                break;
            case 'unblock':
                hasPermission = E_ACCOUNT_STATUS.canUseUnblock(account_status);
                break;
            case 'newTrial':
                hasPermission = tenantUser.enabled;
                break;
            case 'fakeActive': // 跳过邮箱验证
                hasPermission = Boolean(tenantUser?.tenant_id && tenantUser.enabled) && (!accountInfo.email_binding && !tenantUser.fake_active && !!accountInfo.email);
                break;
            case 'editRole':
                hasPermission = Boolean(tenantUser?.tenant_id && tenantUser.enabled);
                break;
            case 'close':
                hasPermission = Boolean(!tenantUser?.tenant_id && tenantUser.enabled);
                break;
            case 'revoke':
                hasPermission = Boolean(!tenantUser?.tenant_id && !tenantUser.enabled);
                break;
            default:
                break;
        }
        return hasPermission;
    }
    getBusinessPackageLimits(privileges = []) {
        let IP = false;
        let Domains = false;
        const privilegeList = this.privilegeDataService.processPrivileges(privileges);
        _.map(privilegeList, privilege => {
            if (privilege?.contracts) {
                _.map(privilege.contracts, contract => {
                    if (contract?.limitation_ways) {
                        if (_.indexOf(contract.limitation_ways, E_PrivliegeLimitationWay.IP_Range) >= 0) {
                            IP = true;
                        }
                        if (_.indexOf(contract.limitation_ways, E_PrivliegeLimitationWay.Domains) >= 0) {
                            Domains = true;
                        }
                    }
                });
            }
        });
        return {
            IP,
            Domains,
        };
    }
    // 批量重发激活邮件
    sendEmailBatch(ids) {
        return this.accountApi.getAccountSendEmail(ids[0]);
    }
    // 批量更新IP限制状态
    setIPStatusBatch(type, ids) {
        return this.accountApi.patchAccountActivation(ids[0]);
    }
    // 批量更新用户角色
    postTenantUserBatchJobRole(data) {
        return this.accountApi.postTenantUserBatchJobRole(data);
    }
    // 批量重发激活邮件
    postSendEmailBatch(data) {
        return this.accountApi.postSendEmailBatch(data);
    }
    // 批量修改ip范围登陆限制
    postIPRestrictBatchEdit(data) {
        return this.accountApi.postIPRestrictBatchEdit(data);
    }
    // 批量移除用户
    postTenantUserBatchDisable(data) {
        return this.accountApi.postTenantUserBatchDisable(data);
    }
    // 批量伪激活
    postTenantUserBatchFakeActive(data) {
        return this.accountApi.postTenantUserBatchFakeActive(data);
    }
    /** 给用户绑定 Cas Id */
    postAccountBind(params) {
        return this.accountApi.postAccountBind(params);
    }
};
AccountDefaultService = __decorate([
    injectable(),
    __param(0, inject(Symbols.AccountApi)),
    __param(1, inject(Symbols.PackageApi)),
    __param(2, inject(Symbols.PrivilegeDataService)),
    __metadata("design:paramtypes", [Object, Object, Object])
], AccountDefaultService);
export { AccountDefaultService };
